'use client';

import { useSearchParams } from 'next/navigation';

import { useTranslations } from 'next-intl';

import { useEffect } from 'react';

import { toast } from '@/app/_components/ui/use-toast';

const IncompleteProfileToast = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();

  // we need a useEffect to avoid infinite rerender
  useEffect(() => {
    if (searchParams.get('incompleteForInvest') === 'true') {
      toast({
        title: t('auth.signUp.toastIncompleteProfile.title'),
        description: t('auth.signUp.toastIncompleteProfile.description'),
        variant: 'default',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="hidden" />; // the components displays nothing but we need to return something
};

export default IncompleteProfileToast;
